import React, { useState } from 'react';
import styles from './App.module.css';
import Menu from './components/Menu/Menu';
import Recommendations from './components/Recommendations/Recommendations';
const r2019 = require('./data/r2018.json');
const r2020 = require('./data/r2019.json');
const r2021 = require('./data/r2020.json');
const r2022 = require('./data/r2021.json');
const r2023 = require('./data/r2022.json');
const r2024 = require('./data/r2023.json');
const r2025 = require('./data/r2024.json');
const r2026 = require('./data/r2025.json');
const l2019 = 'https://www.legis.iowa.gov/docs/publications/DF/1023100.pdf';
const l2020 = 'https://www.legis.iowa.gov/docs/publications/DF/1126149.pdf';
const l2021 = 'https://www.legis.iowa.gov/docs/publications/DF/1208281.pdf';
const l2022 = 'https://www.legis.iowa.gov/docs/publications/DF/1284740.pdf';
const l2023 = 'https://www.legis.iowa.gov/docs/publications/DF/1313462.pdf';
const l2024 = 'https://www.legis.iowa.gov/docs/publications/DF/1441905.pdf';
const l2025 = 'https://www.legis.iowa.gov/docs/publications/DF/1518508.pdf';
const l2026 = 'https://www.legis.iowa.gov/docs/publications/DF/1594762.pdf';

const App = () => {
  const [theYear, setTheYear] = useState(r2026);
  const [theLabel, setTheLabel] = useState('2026');
  const [theLink, setTheLink] = useState(l2026);
  const selectYearHandler = (selectedYear) => {
    switch (selectedYear.toString()) {
      case '2019':
        setTheYear(r2019);
        setTheLink(l2019);
        setTheLabel('2019');
        break;
      case '2020':
        setTheYear(r2020);
        setTheLink(l2020);
        setTheLabel('2020');
        break;
      case '2021':
        setTheYear(r2021);
        setTheLink(l2021);
        setTheLabel('2021');
        break;
      case '2022':
        setTheYear(r2022);
        setTheLink(l2022);
        setTheLabel('2022');
        break;
      case '2023':
        setTheYear(r2023);
        setTheLink(l2023);
        setTheLabel('2023');
        break;
      case '2024':
        setTheYear(r2024);
        setTheLink(l2024);
        setTheLabel('2024');
        break;
      case '2025':
        setTheYear(r2025);
        setTheLink(l2025);
        setTheLabel('2025');
        break;
      case '2026':
        setTheYear(r2026);
        setTheLink(l2026);
        setTheLabel('2026');
        break;
      default:
        setTheYear(r2026);
        setTheLink(l2026);
        setTheLabel('2026');
    }
  };
  return (
    <div className={styles.app}>
      <Menu onSelectYear={selectYearHandler} />
      <Recommendations items={theYear} label={theLabel} link={theLink} />
    </div>
  );
};

export default App;
